<template>
    <div :key="update">
        <span class="text-black" v-if="fileExists" style="word-break: break-word">{{ file.name }}</span>
        <div v-if="!fileExists && isEditable" class="btn-file mt-0" :class="{'d-block': hasDefaultSlot, 'btn btn-primary btn-simple': !hasDefaultSlot}">
            <slot></slot>
            <span class="fileinput-new" v-if="!hasDefaultSlot">
                <i class="tim-icons icon-cloud-upload-94 ml-0 pl-0 mr-2"></i>
                {{fileExists ? changeText : selectText}}
            </span>
            <input type="hidden" value="" name="" />
            <input type="file" id="file" ref="file" @change="handleFile()" />
        </div>

        <base-button class="ml-2 btn-download" v-if="file.download" @click="downloadFile()" size="sm" type="primary">
            <i class="fas fa-download"></i>
            <span class="pl-2">{{downloadText}}</span>
        </base-button>

        <base-button class="ml-2" v-if="fileExists && isEditable" @click="removeFile" size="sm" icon type="danger">
            <i class="fas fa-times"></i>
        </base-button>

        <img style="max-width: 250px;" v-if="preview" class="preview" ref="previewFile" />
    </div>
</template>

<script>
import { FileUploadService } from "@/services";
import swal from 'sweetalert2';

export default {
    name: 'upload-file',
    inject: ['$validator'],
    $_veeValidate:
    {
        value ()
        {
            return this.file.name;
        },
        name ()
        {
            return 'upload-file'
        }
    },
    data() {
        return {
            file: {},
            fileId: null,
            update: 0
        }
    },
    props: {
        selectText: {
            type: String,
            default: function() {
                return this.$t('general.upload')
            }
        },
        changeText: {
            type: String,
            default: function() {
                return this.$t('general.change')
            }
        },
        removeText: {
            type: String,
            default: function() {
                return this.$t('general.remove')
            }
        },
        downloadText: {
            type: String,
            default: function() {
                return this.$t('general.download')
            }
        },
        allowedFileType: {
            type: String,
            default: '*'
        },
        isEditable: {
            type: Boolean,
            default: true
        },
        isEvaluation: {
            type: Boolean,
            required: false,
            default: false
        },
        modelName: {
            type: String,
            required: false,
        },
        section: {
            type: String,
            required: true
        },
        type: {
            type: String,
            required: false
        },
        preview: {
            type: Boolean,
            default: false
        },
        fileData: {
            default: function() {
                return {}
            }
        },
        sizeLimit: {
            required: false,
            type: Number
        }
    },
    model: {
        event: 'file'
    },
    created() {
        this.file = this.fileData;
        if (this.file.id) {
            this.fileId = this.file.id;
        }
    },
    computed: {
        fileExists() {
            return this.file.name !== undefined;
        },
        hasDefaultSlot: function() {
            return this.$slots.default !== undefined && this.$slots.default.length;
        }
    },
    methods: {
        handleFile() {
            if (this.$refs.file.files.length > 0) {
                if (this.allowedFileType !== '*' && !(new RegExp('\.(' + this.allowedFileType + ')').test(this.$refs.file.files[0].name))) {
                    alert('You are not allowed to upload this file type.');
                    return;
                }

                /** file size validation in mega-bytes */
                if (this.sizeLimit && this.$refs.file.files[0].size > (this.sizeLimit * 1024).toFixed(2)) {
                    // let fieldsHtml = '<div class="text-danger">' + `${(this.sizeLimit / 1024).toFixed(2)}` + '</div>';
                    let fieldsHtml = `${(this.sizeLimit / 1024).toFixed(2)}`;
                    // alert(`${msg} ${(this.sizeLimit / 1024).toFixed(2)} MB`);
                    this.update += 1;
                    return swal.fire({
                        title: this.$t('general.notification__warning'),
                        html: this.$t('general.upload_file_validation_msg', [fieldsHtml]),
                        type: 'warning',
                        buttonsStyling: false,
                        confirmButtonClass: 'btn btn-primary btn-fill',
                        confirmButtonText: 'OK'
                    });
                }

                this.file = this.$refs.file.files[0];
                this.file.section = this.section;
                this.file.cntype = this.type;
                if (this.fileId) {
                    this.file.id = this.fileId;
                }
            }
            this.update += 1;
            this.$emit('file', this.file);

            if (this.preview) {
                this.getFilePreview();
            }
        },
        getFilePreview() {
            if (/\.(jpe?g|png|gif)$/i.test(this.file.name)) {
                let reader = new FileReader();
                reader.addEventListener("load", function() {
                    this.$refs['previewFile'].src = reader.result;
                }.bind(this), false);
                reader.readAsDataURL(this.file);
            } else {
                this.$nextTick(function() {
                    this.$refs['previewFile'].src = '';
                });
            }
        },
        downloadFile() {
            var win = window.open(this.file.download, '_blank');
            win.focus();
        },
        async removeFile() {
            if (!(this.file instanceof File) && this.file.id && this.file.download && !confirm(this.$t('general.confirm_file_delete_1') + '\n\r' + this.$t('general.confirm_file_delete_2'))) {
                return;
            }

            if (this.file.id) {

                if (this.modelName)
                {
                    if (FileUploadService.hasOwnProperty('delete' + this.modelName + 'File'))
                    {
                        const loader = this.$loading.show();
                        await FileUploadService['delete' + this.modelName + 'File'](this.file.id);
                        loader.hide();
                    }
                }
                else if (this.isEvaluation) {
                    const loader = this.$loading.show();
                    await FileUploadService.deleteEvaluationFile(this.file.id).then(function(response) {
                        loader.hide();
                    }).catch(function(error) {

                    })
                } else {
                    const loader = this.$loading.show();
                    await FileUploadService.deleteFile(this.file.id).then(function(response) {
                        loader.hide();
                    }).catch(function(error) {

                    })
                }
            }

            this.fileId = null;
            this.file = {};
            this.update += 1;
            this.$emit('file', this.file);

            if (this.preview) {
                this.getFilePreview();
            }
        }
    },
    watch: {
        fileData: {
            handler: function(newValue) {
                if (!(newValue instanceof File)) {
                    this.file = newValue;
                }
            },
            deep: true
        }
    }
}
</script>
<style>
.btn-download {
    height: 1.875rem;
}
</style>
